//  layout for most default files

import { Box } from "@chakra-ui/layout";
import { Navbar } from "./Navbar";

export const Layout = ({ children, wide }) => {
	return (
		<Box d="flex" flexDir="column">
			<Navbar />
			<Box
				id="main"
				mx={
					wide
						? { base: "5", lg: "5rem", xl: "15rem" }
						: { base: "5", lg: "10rem", xl: "25rem" }
				}
				my={10}
				p={15}
				borderRadius="lg"
				// bg={{ base: "white", md: "gray.100" }}
				d="flex"
				flexDir="column"
				alignItems="center"
			>
				{children}
			</Box>
		</Box>
	);
};
